import { userErrorFragment } from './fragmentGeneral.gql';
import cartFragment from './fragmentCart.gql';

const cartLinesUpdate = (
	`mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!, $consent: VisitorConsent) @inContext(visitorConsent: $consent) {
		cartLinesUpdate(cartId: $cartId, lines: $lines) {
			userErrors ${userErrorFragment}
			cart ${cartFragment}
		}
	}`
);

export default cartLinesUpdate;
